import useAcl from '@/utils/hooks/user/useAcl';

//lib
import { NEW_PRICING } from '@/lib/acl/aclRightsList';

//components

import OldBilling from '@/components/pages/settings/subscription-invoices/UserBilling/OldBilling';
import { Billing } from '@/components/pages/settings/subscription-invoices/UserBilling/Billing';

export function UserBilling() {
    const { hasAcl } = useAcl();

    if (!hasAcl(NEW_PRICING.read)) {
        return <OldBilling />;
    }
    return <Billing />;
}
